import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import StudentFilesChildren from "./components/StudentFiles/routes/StudentFilesChildren";
export default store => ({
  path: ":section_id(/:nodeId)",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(
          /* webpackChunkName: "course-studentPortfolio" */ "./components"
        ),
        import(
          /* webpackChunkName: "course-studentPortfolio" */ "Projects/modules/ProjectModules.js"
        ),
        import(
          /* webpackChunkName: "course-studentPortfolio" */ "Administrator/modules/CommonModule"
        ),
        import(
          /* webpackChunkName: "course-studentPortfolio" */ "StudentSetup/components/EditStudent/containers/StudentDetailsModule"
        ),
        import(
          /* webpackChunkName: "course-studentPortfolio" */ "Teacher/routes/StudentGoals/modules/StudentGoalsModules"
        ),
      ]).then(
        ([
          importedModule0,
          importedModule1,
          importedModule2,
          importedModule3,
          importedModule4,
        ]) => {
          const component = importedModule0.default;
          const projectReducer = importedModule1;
          const commonReducerForAdmin = importedModule2;
          const studentDetailsModule = importedModule3;
          const studentGoalsModule = importedModule4;
          injectReducer(store, {
            key: projectReducer.NAME,
            reducer: projectReducer.default,
          });
          injectReducer(store, {
            key: commonReducerForAdmin.NAME,
            reducer: commonReducerForAdmin.default,
          });
          injectReducer(store, {
            key: studentDetailsModule.NAME,
            reducer: studentDetailsModule.default,
          });
          injectReducer(store, {
            key: studentGoalsModule.NAME,
            reducer: studentGoalsModule.default,
          });
          return component;
        }
      )
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [StudentFilesChildren(store)],
});
